module.exports = __webpack_public_path__ + "img/icon-add.9e45a4ae.svg";